
<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2502 4.66667V12.25H2.75016V4.66667M6.8335 7H9.16683M1.5835 1.75H14.4168V4.66667H1.5835V1.75Z"
      stroke="#F7F8FD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>